/* eslint-disable no-tabs */
import { gql } from '@urql/core';

export const GET_DOSSIERS = gql`
  query dossiers($input: DossierFilterInput, $orderBy: [QueryDossiersOrderByOrderByClause!], $page: Int, $limit: Int) {
    dossiers(input: $input, orderBy: $orderBy, page: $page, first: $limit) {
      data {
        id
        created_at
        properties {
          ... on AdvisorProperty {
            id
            dossier_id
            status_updated_at
            passes_at
            created_at
            updated_at
            preferred_passes_at
            appointment_at
            appointment_location
            interest_to_pay
            calculated_monthly_repayment
            status
            financing_type
            advisor_status {
              text
              tooltip
              needs_attention
              status
            }
            accountManager {
              first_name
              last_name
            }
            entity {
              id
              property_id
              street_name
              house_number
              house_number_addition
              postal_code
              city
              municipality
              province
              market_value
              loan
              value
              loan_to_value
              title_property_type
              title_property_type_label
              title_property_type_other
              image_urls {
                c
                m
                s
                l
              }
            }
            customer {
              id
              name
              initials
              first_name
              last_name
              infix
              gender
            }
            employee {
              id
              avatar
              avatar_with_seen_status
              name
              first_name
              last_name
              email
            }
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastPage
        perPage
        total
      }
    }
  }`;

export const GET_DOSSIER = gql`
  query dossier($id: ID!) {
    dossier(id: $id) {
      id
      total_loan
      weighted_average_interest
      created_at
      properties {
        ... on AdvisorProperty {
          id
          financing_type
          main_liable_name
          interest_to_pay
          passes_at
          status
          project_or_construction
          advisor_status {
            text
            tooltip
            status
          }
          entity {
            street_name
            house_number
            house_number_addition
            city
            loan
            loan_to_value
            value
            image_urls {
              c
              m
              s
              l
            }
          }
          employee {
            id
            avatar
            avatar_with_seen_status
            name
            first_name
            last_name
            email
          }
          customer {
            id
            first_name
            last_name
          }
          realEstateSpecialist {
            name
          }
        }
      }
    }
  }
`;

export const GET_DOSSIER_TITLE = gql`
  query dossier($id: ID!) {
    dossier(id: $id) {
      id
      properties {
        ... on AdvisorProperty {
          entity {
            street_name
            house_number
            city
          }
        }
      }
    }
  }
`;

export const GET_DOSSIER_ID = gql`
  query dossier($id: ID!) {
    dossier(id: $id) {
      id
    }
  }
`;

export const GET_TOTALS = gql`
  query totals($newDossiersRangeDays: String, $loanRangeDays: String) {
  totals(input: {new_dossiers_range: $newDossiersRangeDays, loan_amount_range: $loanRangeDays}) {
    new_dossiers {
      current
      previous
      comparison {
        value
        sign
        label
      }
    }
    loan_amount {
      current
      previous
      comparison {
        value
        sign
        label
      }
    }
  }
}
`;
